module.exports = __webpack_public_path__ + "img/Ic_remove_mylist.132016bf.svg";